import {
  clearSrDocumentStatusAction,
  clearSrDocumentStatusErrors,
  createSrDocumentStatus,
} from 'actions/srDocuments/srDocumentStatusActions'
import AdminForm from 'components/admin/AdminForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const SrDocumentStatusCreate = ({ formId, params, setParams, closeModal }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, statusErrors } = useSelector(
    (state) => state.srDocumentStatuses
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentStatusErrors())
      dispatch(clearSrDocumentStatusAction())
    }
  }, [dispatch])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        name: '',
      })
    }
  }, [params, setParams])

  useEffect(() => {
    if (lastAction === 'create') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(createSrDocumentStatus(params))
      }}
      className="form container"
      noValidate
    >
      <AdminForm params={params} setParams={setParams} errors={statusErrors} />
    </form>
  )
}

export default SrDocumentStatusCreate
